export const iosUrl='https://apps.apple.com/kg/app/smartlife-armenia/id1607084056';
export const androidUrl='https://play.google.com/store/apps/details?id=com.sossystems.smartlife&hl=en_IN';
